import axios from "axios";
import { getNodeServerUrl } from "@utils/getNodeUrl";
import { getUniqueListBy } from "@components/Common/Function";

export const getDealerPhysicalVerificationDataApi = async ( data ) => {
  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  // Get tty codes only & make a list
  let TTYCodes = [];
  const TTYCodeData = getUniqueListBy(data, "SH2_Code__c");
  TTYCodeData?.forEach((item) => { TTYCodes.push(item?.SH2_Code__c) });
  const TTYCodesList = TTYCodes;

  const nodeBaseUrl = getNodeServerUrl();
  
  const options = {
    url: `${nodeBaseUrl}/dealer/getDealerPhysicalVerificationData`,
    method: "post",
    headers: headers,
    data: { TTYCodesList }
  };
  try {
    const res = await axios(options);
    return res;
  } catch (error) {
    const errors = error?.response?.data?.error?.msg;
    if (errors) {
      return { error: error?.response?.data?.error?.msg };
    } else {
      return { error: "Something Went Wrong" };
    }
  }
};
